// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__18760","label":"Section_label__131hZ","contentWrap":"Section_contentWrap__qVqy1","footer":"Section_footer__ah1cf","footerInner":"Section_footerInner__2uje0"};